export enum UserStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export const userStatuses = () => {
  return Object.keys(UserStatus).map((status) => UserStatus[status]);
};
